module.exports = __webpack_public_path__ + "static/media/ET077 new.c1e7d9a0.jpg";